// Fecha de Hoy
export const obtenerFechaHoy = () => {
    const hoy = new Date();
    const year = hoy.getFullYear();
    const month = String(hoy.getMonth() + 1).padStart(2, '0'); // Los meses comienzan en 0
    const day = String(hoy.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`; // Formato YYYY-MM-DD
};